import { getCountryByLocale, getLocaleParts, type LocaleIso } from '../i18n';

/**
 * format a raw price (number) into a localized, currency‐aware string.
 */
export function formatPrice(price?: number, locale?: LocaleIso): string | undefined {
  if (!price || !locale) return undefined;

  const country = getCountryByLocale(locale);

  const { countryCode, languageCode } = getLocaleParts(locale);

  return country?.getValueWithCurrency(price, countryCode, languageCode);
}
